<template>
  <div class="col-lg-9 col-xl-9">
    <ul
      v-show="!loadingResults && !withoutResults"
      class="busca-resultados"
    >
      <li
        v-for="(item, index) in resultItems"
        :key="index"
        class="result__item mb-32"
      >
        <SearchResultItem :item="item" />
      </li>

      <!-- pagination -->
      <li class="border-bottom-none">
        <SearchResultPagination />
      </li>
    </ul>
    <div
      v-if="loadingResults"
      class="
        w-100
        h-100
        d-flex
        justify-content-center
        align-items-center
        opacity--05
      "
    >
      <div class="spinner-border" role="status">
        <span class="visually-hidden"></span>
      </div>
    </div>
    <div v-else-if="withoutResults" class="d-flex justify-content-center">
      <h2 class="text__without-result">Nenhum resultado encontrado para sua busca</h2>
    </div>
  </div>
</template>

<script>
import SearchResultItem from '../components/SearchResultItem.vue'
import { useSearch } from '../composables/useSearch.js'
import SearchResultPagination from '../components/SearchResultPagination.vue'
export default {
  components: { SearchResultItem, SearchResultPagination },
  name: 'SearchResults',
  setup() {
    const { resultItems, loadingResults, withoutResults } = useSearch()
    return { resultItems, loadingResults, withoutResults }
  },
}
</script>
